import { AddMemberFormDataUpdated } from "./AddMemberForm";
import { FormErrorType } from "./formElements/BasicTextField";

import { useEffect, useState } from "react";
import moment from "moment-timezone";
import {
  memberMobileConstraints,
  mobileConstraints,
} from "../../constants/AppConstants";
import { URLConstants } from "../../constants/ApiConstants";
export const inputStateUpdate = (
  stateKey: string,
  setState: Function,
  value: string | string[] | boolean,
  cbf?: Function
) => {
  if (!cbf) {
    setState((prevState: AddMemberFormDataUpdated) => {
      return { ...prevState, [stateKey]: value };
    });
  } else {
    setState((prevState: AddMemberFormDataUpdated) => {
      return { ...prevState, [stateKey]: cbf() };
    });
  }
};

export const basicTextFieldValidator = (
  stateKey: string,
  textFieldValue: string,
  setTextFieldValue: Function,
  setError: Function,
  disableSubmit: Function,
  visited: boolean,
  matcherValue?: string,
  loyaltyPointsValue?: number,
  selectType?: string | String,
  existingValues?: string[],
  applyStrictMobileValidation?: boolean,
  isSingapore?: boolean,
  allowZeroValue?: boolean,
) => {
  let textFieldNewValue = Number(textFieldValue);

  switch (stateKey) {
    case "nricNo":
      if (textFieldValue.length === 0 && visited) {
        disableSubmit(true);
        setError((prev: FormErrorType) => {
          return { ...prev, error: true, message: "required field" };
        });
      } else if (!/^[0-9]*[0-9]$/.test(textFieldValue) && visited) {
        setTextFieldValue(textFieldValue.slice(0, textFieldValue.length - 1));
      } else {
        disableSubmit(false);
        setError((prev: FormErrorType) => {
          return { ...prev, error: false };
        });
      }
      break;
    case "zip":
      if (textFieldValue.length > 10 && visited) {
        disableSubmit(true);
        setError((prev: FormErrorType) => {
          return { ...prev, error: true, message: "Maximum of 10 digits" };
        });
      } else {
        disableSubmit(false);
        setError((prev: FormErrorType) => {
          return { ...prev, error: false };
        });
      }
      break;

    case "mobile":
    case "mobileWOCc":
      // Ensure only digits are entered
      if (!/^[0-9]*$/.test(textFieldValue) && visited) {
        setTextFieldValue(textFieldValue.slice(0, textFieldValue.length - 1));
        break;
      }
      // Disallow all zeros
      if (/^0+$/.test(textFieldValue)) {
        disableSubmit(true);
        setError((prev: FormErrorType) => ({
          ...prev,
          error: true,
          message: "Mobile number cannot be all zeros",
        }));
        break;
      }

      // Apply strict mobile validation if enabled (for AddMemberForm)
      if (applyStrictMobileValidation && visited) {
        if (textFieldValue.length > 0) {
          // Singapore validation: strict regex to prevent country code 65
          if (isSingapore) {
            const mobileRegex = /^(?!65)(?:\+?\d{8,15}|\d{16})$/;
            if (!mobileRegex.test(textFieldValue)) {
              disableSubmit(true);
              setError((prev: FormErrorType) => {
                return {
                  ...prev,
                  error: true,
                  message: "Enter Valid Mobile Number without country code",
                };
              });
              break;
            } else {
              disableSubmit(false);
              setError((prev: FormErrorType) => {
                return { ...prev, error: false };
              });
            }
          } else {
            // Other countries: use default length validation
            if (
              textFieldValue.length < mobileConstraints.mobileMin ||
              textFieldValue.length > mobileConstraints.mobileMax
            ) {
              disableSubmit(true);
              setError((prev: FormErrorType) => {
                return {
                  ...prev,
                  error: true,
                  message: "Please Enter Valid Mobile Number",
                };
              });
              break;
            } else {
              disableSubmit(false);
              setError((prev: FormErrorType) => {
                return { ...prev, error: false };
              });
            }
          }
        } else {
          // Empty field - clear error
          disableSubmit(false);
          setError((prev: FormErrorType) => {
            return { ...prev, error: false };
          });
        }
        break;
      }
      break;

    case "iuNumber1":
      if (textFieldValue.length !== 10 && visited) {
        disableSubmit(true);
        setError((prev: FormErrorType) => {
          return {
            ...prev,
            error: true,
            message: "Please Enter Valid IU Number",
          };
        });
      } else if (!/^[0-9]*[0-9]$/.test(textFieldValue) && visited) {
        setTextFieldValue(textFieldValue.slice(0, textFieldValue.length - 1));
      } else {
        disableSubmit(false);
        setError((prev: FormErrorType) => {
          return { ...prev, error: false };
        });
      }
      break;
    case "iuNumber2":
      if (textFieldValue.length !== 10 && visited) {
        disableSubmit(true);
        setError((prev: FormErrorType) => {
          return {
            ...prev,
            error: true,
            message: "Please Enter Valid IU Number",
          };
        });
      } else if (!/^[0-9]*[0-9]$/.test(textFieldValue) && visited) {
        setTextFieldValue(textFieldValue.slice(0, textFieldValue.length - 1));
      } else {
        disableSubmit(false);
        setError((prev: FormErrorType) => {
          return { ...prev, error: false };
        });
      }
      break;

    case "mobileNumber":
      // if (textFieldValue.length === 0 && visited) {
      //   disableSubmit(true);
      //   setError((prev: FormErrorType) => {
      //     return { ...prev, error: true, message: "Required field" };
      //   });
      // }
      if (
        (textFieldValue.length < mobileConstraints.mobileMin ||
          textFieldValue.length > mobileConstraints.mobileMax) &&
        visited
      ) {
        disableSubmit(true);
        setError((prev: FormErrorType) => {
          return {
            ...prev,
            error: true,
            message: "Please Enter Valid Mobile Number",
          };
        });
      } else if (!/^[0-9]*[0-9]$/.test(textFieldValue) && visited) {
        setTextFieldValue(textFieldValue.slice(0, textFieldValue.length - 1));
      } else {
        disableSubmit(false);
        setError((prev: FormErrorType) => {
          return { ...prev, error: false };
        });
      }
      break;

      case "email":
      if (textFieldValue.length === 0 && visited) {
        disableSubmit(true);
        setError((prev: FormErrorType) => {
          return { ...prev, error: true, message: "Required field" };
        });
      } else {
        const trimmedValue = textFieldValue.trim();

        if (!/^[a-zA-Z0-9.@_-]+$/.test(trimmedValue) && visited) {
          setTextFieldValue(textFieldValue.slice(0, textFieldValue.length - 1));
        } else if (
          !/^[^\s]+@[^\s]+\.[^\s]+$/.test(trimmedValue) &&
          visited
        ) {
          setError((prev: FormErrorType) => {
            return { ...prev, error: true, message: "Invalid email" };
          });
        } else {
          setTextFieldValue(trimmedValue);
          disableSubmit(false);
          setError((prev: FormErrorType) => {
            return { ...prev, error: false };
          });
        }
      }
      break;

    case "first_name":
      if (textFieldValue.length === 0 && visited) {
        disableSubmit(true);
        setError((prev: FormErrorType) => {
          return { ...prev, error: true, message: "Required field" };
        });
      } else if (!/^[a-zA-Z\s]+$/.test(textFieldValue) && visited) {
        disableSubmit(true);
        setError((prev: FormErrorType) => {
          return { ...prev, error: true, message: "Only letters allowed" };
        });
      } else if (textFieldValue.length <= 1 && visited) {
        disableSubmit(true);
        setError((prev: FormErrorType) => {
          return {
            ...prev,
            error: true,
            message: "Min 2 characters",
          };
        });
      } else {
        disableSubmit(false);
        setError((prev: FormErrorType) => {
          return { ...prev, error: false };
        });
      }
      break;

    case "last_name":
      if (textFieldValue.length === 0 && visited) {
        disableSubmit(true);
        setError((prev: FormErrorType) => {
          return { ...prev, error: true, message: "Required field" };
        });
      } else if (!/^[a-zA-Z\s]+$/.test(textFieldValue) && visited) {
        disableSubmit(true);
        setError((prev: FormErrorType) => {
          return { ...prev, error: true, message: "Only letters allowed" };
        });
      } else if (textFieldValue.length <= 1 && visited) {
        disableSubmit(true);
        setError((prev: FormErrorType) => {
          return {
            ...prev,
            error: true,
            message: "Min 2 characters",
          };
        });
      } else {
        disableSubmit(false);
        setError((prev: FormErrorType) => {
          return { ...prev, error: false };
        });
      }
      break;

    case "password":
      if (textFieldValue.length === 0 && visited) {
        disableSubmit(true);
        setError((prev: FormErrorType) => {
          return { ...prev, error: true, message: "Required field" };
        });
      } else if (
        !/^(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=])((?=.*\d)).*$/.test(
          textFieldValue
        ) &&
        visited
      ) {
        disableSubmit(true);
        setError((prev: FormErrorType) => {
          return {
            ...prev,
            error: true,
            message:
              "Require at least one uppercase, lowercase, number and special char",
          };
        });
      } else if (textFieldValue.length < 6 && visited) {
        disableSubmit(true);
        setError((prev: FormErrorType) => {
          return { ...prev, error: true, message: "Min 6 characters" };
        });
      } else {
        setError((prev: FormErrorType) => {
          return { ...prev, error: false };
        });
      }

      break;

    case "confirm_password":
      if (textFieldValue.length === 0 && visited) {
        disableSubmit(true);
        setError((prev: FormErrorType) => {
          return { ...prev, error: true, message: "Required field" };
        });
      } else if (!(textFieldValue === matcherValue) && visited) {
        disableSubmit(true);
        setError((prev: FormErrorType) => {
          return { ...prev, error: true, message: "Password does not match" };
        });
      } else {
        disableSubmit(false);
        setError((prev: FormErrorType) => {
          return { ...prev, error: false };
        });
      }

      break;
    case "merchant_name":
      if (textFieldValue.length === 0 && visited) {
        disableSubmit(true);
        setError((prev: FormErrorType) => {
          return { ...prev, error: true, message: "Required field" };
        });
      } else if (textFieldValue?.length > 0) {
        textFieldValue = textFieldValue
          .replace(/[^a-zA-Z0-9]/g, ".")
          .replace(" ", ".");
        if (existingValues?.some((x) => x === textFieldValue)) {
          disableSubmit(true);
          setError((prev: FormErrorType) => {
            return {
              ...prev,
              error: true,
              message: "merchant name already exist",
            };
          });
        } else {
          disableSubmit(false);
          setError((prev: FormErrorType) => {
            return { ...prev, error: false };
          });
        }
      } else {
        disableSubmit(false);
        setError((prev: FormErrorType) => {
          return { ...prev, error: false };
        });
      }
      break;
    case "directory_category":
      if (textFieldValue.length === 0 && visited) {
        disableSubmit(true);
        setError((prev: FormErrorType) => {
          return { ...prev, error: true, message: "Required field" };
        });
      } else {
        disableSubmit(false);
        setError((prev: FormErrorType) => {
          return { ...prev, error: false };
        });
      }
      break;
    case "directory_subcategory":
      if (textFieldValue.length === 0 && visited) {
        disableSubmit(true);
        setError((prev: FormErrorType) => {
          return { ...prev, error: true, message: "Required field" };
        });
      } else {
        disableSubmit(false);
        setError((prev: FormErrorType) => {
          return { ...prev, error: false };
        });
      }
      break;
    case "zone":
      if (textFieldValue.length === 0 && visited) {
        disableSubmit(true);
        setError((prev: FormErrorType) => {
          return { ...prev, error: true, message: "Required field" };
        });
      } else {
        disableSubmit(false);
        setError((prev: FormErrorType) => {
          return { ...prev, error: false };
        });
      }
      break;
    case "username":
      if (textFieldValue.length === 0 && visited) {
        disableSubmit(true);
        setError((prev: FormErrorType) => {
          return { ...prev, error: true, message: "Required field" };
        });
      } else {
        disableSubmit(false);
        setError((prev: FormErrorType) => {
          return { ...prev, error: false };
        });
      }
      break;
    case "unit_number":
      if (textFieldValue.length === 0 && visited) {
        disableSubmit(true);
        setError((prev: FormErrorType) => {
          return { ...prev, error: true, message: "Required field" };
        });
      } else {
        disableSubmit(false);
        setError((prev: FormErrorType) => {
          return { ...prev, error: false };
        });
      }
      break;
    case "participationLevel":
      if (textFieldValue.length === 0 && visited) {
        disableSubmit(true);
        setError((prev: FormErrorType) => {
          return { ...prev, error: true, message: "Required field" };
        });
      } else {
        disableSubmit(false);
        setError((prev: FormErrorType) => {
          return { ...prev, error: false };
        });
      }
      break;
    case "status":
      if (textFieldValue.length === 0 && visited) {
        disableSubmit(true);
        setError((prev: FormErrorType) => {
          return { ...prev, error: true, message: "Required field" };
        });
      } else {
        disableSubmit(false);
        setError((prev: FormErrorType) => {
          return { ...prev, error: false };
        });
      }
      break;
    case "company_name":
      if (textFieldValue.length === 0 && visited) {
        disableSubmit(true);
        setError((prev: FormErrorType) => {
          return { ...prev, error: true, message: "Required field" };
        });
      } else {
        disableSubmit(false);
        setError((prev: FormErrorType) => {
          return { ...prev, error: false };
        });
      }
      break;
    case "pin":
      if (textFieldValue.length === 0 && visited) {
        disableSubmit(true);
        setError((prev: FormErrorType) => {
          return { ...prev, error: true, message: "Required field" };
        });
      } else if (!/^[0-9]*[0-9]$/.test(textFieldValue) && visited) {
        disableSubmit(true);
        setTextFieldValue(textFieldValue.slice(0, textFieldValue.length - 1));
      } else {
        disableSubmit(false);
        setError((prev: FormErrorType) => {
          return { ...prev, error: false };
        });
      }
      break;
    case "confirmPin":
      if (textFieldValue.length === 0 && visited) {
        disableSubmit(true);
        setError((prev: FormErrorType) => {
          return { ...prev, error: true, message: "Required field" };
        });
      } else if (!(textFieldValue === matcherValue) && visited) {
        disableSubmit(true);
        setError((prev: FormErrorType) => {
          return { ...prev, error: true, message: "PIN does not match" };
        });
      } else {
        disableSubmit(false);
        setError((prev: FormErrorType) => {
          return { ...prev, error: false };
        });
      }
      break;
    case "promoImage":
      if (textFieldValue.length === 0 && visited) {
        disableSubmit(true);
        setError((prev: FormErrorType) => {
          return { ...prev, error: true, message: "Required field" };
        });
      } else {
        disableSubmit(false);
        setError((prev: FormErrorType) => {
          return { ...prev, error: false };
        });
      }
      break;
    case "detailsImage":
      if (textFieldValue.length === 0 && visited) {
        disableSubmit(true);
        setError((prev: FormErrorType) => {
          return { ...prev, error: true, message: "Required field" };
        });
      } else {
        disableSubmit(false);
        setError((prev: FormErrorType) => {
          return { ...prev, error: false };
        });
      }
      break;
    case "amount":
      if (+textFieldValue <= 0 && visited && textFieldValue.length !== 0) {
        disableSubmit(true);
        setError((prev: FormErrorType) => {
          return { ...prev, error: true, message: "Invalid Amount" };
        });
      } else if (+textFieldValue > 10000 && visited) {
        disableSubmit(true);
        setError((prev: FormErrorType) => {
          return {
            ...prev,
            error: true,
            message: "Maximum amount allowed is $10000",
          };
        });
      } else {
        disableSubmit(false);
        setError((prev: FormErrorType) => {
          return { ...prev, error: false };
        });
      }
      break;
    case "adminAmount":
    case "receiptAmount":
      if (+textFieldValue < 0 && visited && textFieldValue.length !== 0) {
        disableSubmit(true);
        setError((prev: FormErrorType) => {
          return { ...prev, error: true, message: "Invalid Amount" };
        });
      } else if (
        +textFieldValue === 0 &&
        !allowZeroValue &&
        visited &&
        textFieldValue.length !== 0
      ) {
        disableSubmit(true);
        setError((prev: FormErrorType) => {
          return { ...prev, error: true, message: "Invalid Amount" };
        });
        // } else if (+textFieldValue < 20 && visited) {
        //   disableSubmit(true);
        //   setError((prev: FormErrorType) => {
        //     return { ...prev, error: true, message: "Minimum amount is $20" };
        //   });
      } else {
        disableSubmit(false);
        setError((prev: FormErrorType) => {
          return { ...prev, error: false };
        });
      }
      break;
    case "points":
      if (textFieldValue.length === 0 && visited) {
        disableSubmit(true);
        setError((prev: FormErrorType) => {
          return { ...prev, error: true, message: "Required field" };
        });
      } else if (
        loyaltyPointsValue !== undefined &&
        selectType === "Points Deduction" &&
        textFieldNewValue > loyaltyPointsValue
      ) {
        disableSubmit(true);
        setError((prev: FormErrorType) => {
          return { ...prev, error: true, message: "Not enough points" };
        });
      } else if (+textFieldValue < 0 && visited) {
        disableSubmit(true);
        setError((prev: FormErrorType) => {
          return {
            ...prev,
            error: true,
            message: "Points can't be less than 0",
          };
        });
      } else {
        disableSubmit(false);
        setError((prev: FormErrorType) => {
          return { ...prev, error: false };
        });
      }
      break;
    case "remarks":
      if (textFieldValue.length === 0 && visited) {
        disableSubmit(true);
        setError((prev: FormErrorType) => {
          return { ...prev, error: true, message: "Required field" };
        });
      } else {
        disableSubmit(false);
        setError((prev: FormErrorType) => {
          return { ...prev, error: false };
        });
      }
      break;

    default:
      disableSubmit(false);

      disableSubmit(false);

      setError((prev: FormErrorType) => {
        return { ...prev, error: false };
      });
  }
};

const getSavedValue = (key: string, initialValue: string | Function) => {
  const savedValue = JSON.parse(localStorage?.getItem(key) ?? "{}");

  if (savedValue) return savedValue;

  if (initialValue instanceof Function) return initialValue();

  return initialValue;
};

export const UseLocalStorage = (key: string, initialValue: string) => {
  const [value, setValue] = useState(() => {
    return getSavedValue(key, initialValue);
  });

  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(value));
  }, [value]);

  return [value, setValue];
};

export const findChangedValues: any = (obj1: any, obj2: any) => {
  const differentPairs: any = {};

  for (const key in obj1) {
    if (obj1[key] !== obj2[key]) {
      differentPairs[key] = obj2[key];
    }
  }

  return differentPairs;
};

export const getDomainUrl = () => {
  const path = window.location.pathname;
  const pathSegments = path.split("/");
  const domain = pathSegments && pathSegments.length > 1 ? pathSegments[1] : "";
  if (
    domain === process.env.REACT_APP_ADMIN_DOMAIN ||
    domain === process.env.REACT_APP_CSA_DOMAIN ||
    domain === process.env.REACT_APP_MERCHANT_DOMAIN
  ) {
    return domain;
  } else {
    return "";
  }
};
export const getUserFromURL = () => {
  const userTypeFromUrl = window.location.pathname;
  return userTypeFromUrl.includes("admin") ? "admin" : "merchant";
};
export function formatDate1(inputDateString: any) {
  const formattedDate = moment(inputDateString).format(
    "D MMMM YYYY, h:mm:ss a"
  );
  return formattedDate;
  // const originalTime = moment(inputDateString);
  // const desiredTimeZone = 'Asia/Singapore';
  // const singaporeTime = originalTime.tz(desiredTimeZone);
  // const singaporeTimeStr = singaporeTime.format('YYYY-MM-DD hh:mm:ss a');
  // return singaporeTimeStr;
  // Parse the input date string into a JavaScript Date object
  // var inputDate = new Date(inputDateString);

  // // Months array for formatting
  // var months = [
  //   "January",
  //   "February",
  //   "March",
  //   "April",
  //   "May",
  //   "June",
  //   "July",
  //   "August",
  //   "September",
  //   "October",
  //   "November",
  //   "December",
  // ];

  // // Get the components of the date
  // var day = inputDate.getDate();
  // var month = months[inputDate.getMonth()];
  // var year = inputDate.getFullYear();
  // var hours = inputDate.getHours();
  // var minutes = inputDate.getMinutes();
  // var seconds = inputDate.getSeconds();
  // var ampm = hours >= 12 ? "PM" : "AM";

  // // Format the date in the desired output format
  // var formattedDate = `${day} ${month} ${year} ${hours}:${minutes}:${seconds} ${ampm}`;

  // return formattedDate;
}
export function formatDateReport(dateString: string | number | Date) {
  const date = new Date(dateString);
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const day = date.getDate();
  const monthIndex = date.getMonth();
  const year = date.getFullYear();

  return `${day} ${monthNames[monthIndex]} ${year}`;
}

export const generateExpiryDateOptions = () => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = currentDate.getMonth();
  const currentDay = currentDate.getDate();

  const options = [];

  if (currentMonth > 5 || (currentMonth === 5 && currentDay >= 30)) {
    options.push({
      display: `December 31, ${currentYear}`,
      value: `${currentYear}-12-31T23:59:59`,
    });
    options.push({
      display: `June 30, ${currentYear + 1}`,
      value: `${currentYear + 1}-06-30T23:59:59`,
    });
  } else {
    options.push({
      display: `June 30, ${currentYear}`,
      value: `${currentYear}-06-30T23:59:59`,
    });
    options.push({
      display: `December 31, ${currentYear}`,
      value: `${currentYear}-12-31T23:59:59`,
    });
  }

  return options;
};

export const formatToLocalTime = (inputDatetime: string) => {
  inputDatetime.replace(" ", "T");
  inputDatetime = inputDatetime + "+08:00";
  return inputDatetime;
};

export const getEncodedLastkey = (value: any) => {
  return `lastKey=${encodeURIComponent(JSON.stringify(value))}`;
};

export const getEncodedValue = (value: string) => {
  return value ? encodeURIComponent(value) : value;
};

export const getURLPath = () => {
  const domain = getDomainUrl();
  const hostName = window.location.hostname;
  const invalidURL = `invalid-url`;
  switch (hostName) {
    case URLConstants.UATadmiURL:
    case URLConstants.adminURL:
      return domain === process.env.REACT_APP_ADMIN_DOMAIN
        ? domain
        : invalidURL;
    case URLConstants.UATMerchantURL:
    case URLConstants.merchantURL:
      return domain === process.env.REACT_APP_MERCHANT_DOMAIN
        ? domain
        : invalidURL;
    case URLConstants.UATCSadminURL:
    case URLConstants.csAdminURL:
      return domain === process.env.REACT_APP_CSA_DOMAIN ? domain : invalidURL;
    default:
      return domain;
  }
  // suntec-pv.capillarytech.com
};

export const getURLDomain = () => {
  const hostName = window.location.hostname;
  switch (hostName) {
    case URLConstants.UATadmiURL:
    case URLConstants.adminURL:
      return process.env.REACT_APP_ADMIN_DOMAIN;
    case URLConstants.UATMerchantURL:
    case URLConstants.merchantURL:
      return process.env.REACT_APP_MERCHANT_DOMAIN;
    case URLConstants.UATCSadminURL:
    case URLConstants.csAdminURL:
      return process.env.REACT_APP_CSA_DOMAIN;
    default:
      return "";
  }
};

export const getURLToLoad = () => {
  const defaultDomain = getDomainUrl();
  let domain = "";
  if (!defaultDomain) {
    const urlDomain = getURLDomain();
    domain = urlDomain ? `${urlDomain}/login` : "invalid-url";
  } else if (
    window.location.pathname.includes(defaultDomain) ||
    defaultDomain === window.location.pathname
  ) {
    domain = "/login";
  } else {
    domain = "invalid-url";
  }

  return domain;
};
